import Modal from '@atlaskit/modal-dialog';

const DeleteEntityAppPopup = ({
  entityApp,
  close,
}: {
  entityApp: EntityDetails.App;
  close: () => void;
}) => {
  return (
    <Modal onClose={close} shouldScrollInViewport={false} autoFocus={false}>
      <h1>{entityApp.title}</h1>
    </Modal>
  );
};

export default DeleteEntityAppPopup;
